/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-17T14:56:07-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-13T09:35:16-07:00
*/



import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { dimensions, color, textColor, borders } from '../../style';
import Container from './Container';
import { css, StyleSheet } from 'aphrodite/no-important';

const style = StyleSheet.create({
  subNav: {
    backgroundColor: '#fff',
    borderBottom: borders.DEFAULT,
  },

  subNav_vertical: {
    [dimensions.SCREEN_MIN_SM]: {
      borderBottomWidth: '0',
      borderRightWidth: '2px'
    }
  },

  tabList: {
    margin: '0',
    padding: '0',
  },

  item: {
    borderStyle: 'solid',
    borderColor: 'transparent',
    borderWidth: '0',
    fontSize: '12px',
    borderBottomWidth: '2px',
    display: 'table-cell',
    fontWeight: '600',
    ...textColor.DARK
  },

  isSelected: {
    borderColor: color.BRAND_1,
    color: color.BRAND_1,
  },

  link: {
    display: 'inline-block',
    padding: '14px 22px',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',

    [dimensions.SCREEN_MAX_SM]: {
      padding: '14px'
    }
  },

  verticalLink: {
    [dimensions.SCREEN_MIN_SM]: {
      display: 'block'
    }
  },

  verticalItem: {
    [dimensions.SCREEN_MIN_SM]: {
      borderLeftWidth: '2px',
      borderBottomWidth: '0',
      display: 'block',
    }
  },
  container: {
    [dimensions.SCREEN_MIN_SM]: {
      padding: '0'
    }
  }
});

class SubNav extends Component {

  constructor(props) {
    super(props);
    this.buildMenu = this.buildMenu.bind(this);
  }

  buildMenu() {
    // get page url after "/"
    let activePage = window.location.href;
    activePage = activePage.replace("http://","");
    activePage = activePage.replace("https://","")
    activePage = "/"+activePage.split(/\/(.+)/)[1];

    let pages = this.props.pages;
    let urls = this.props.urls;

    // build each menu item.
    var menuItems = [];
    for(var i=0;i<pages.length;i++) {
      menuItems.push(
        <li key={urls[i]} className={css(style.item, this.props.vertical && style.verticalItem, urls[i] === activePage && style.isSelected)}>
          <Link to={urls[i]} className={css(style.link, this.props.vertical && style.verticalLink)}>{pages[i]}</Link>
        </li>);
    }
    return menuItems;
  }

  render() {
    // render submenu as component.
    return (
      <div className={css(style.subNav, this.props.vertical && style.subNav_vertical)}>
        <Container fullWidth styles={this.props.vertical && style.container}>
          <ul className={css(style.tabList)}>
            {this.buildMenu()}
          </ul>
        </Container>
      </div>
    );
  }
}

SubNav.propTypes = {
  pages: PropTypes.array.isRequired,
  urls: PropTypes.array.isRequired,
};


export default SubNav;



// WEBPACK FOOTER //
// ./src/components/blocks/SubNav.jsx